import { HomeGroupIcon } from './HomeGroupIcon';

/**
 * author: Michael Richins
 * id B4E54DBF-164E-41D3-8C9F-D7E67C9F9B10
 * name home-group
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-group.svg
 * tags
 * - Home Automation 
 */
export const EstateIcon = HomeGroupIcon;
export default EstateIcon